<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-about-author element-with-heading" id="about-the-author">
<div class="heading heading-with-title heading-without-image" id="about-the-author-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Love best-selling fiction?</h1>
</div>
</div>
</div>
</div>
<div class="text" id="about-the-author-text">
<div class="inline-image inline-image-kind-freestanding inline-image-size-large inline-image-flow-center inline-image-flow-within-text inline-image-aspect-wide inline-image-without-caption inline-image-begins-section inline-image-before-element-end">
<div class="inline-image-container">
<a class="link-contains-image" href="http://deals.bloodhoundbooks.com/bloodhound-deals" target="_blank">
<img alt="" src="images/back-of-kindle.jpg"/>
</a>
</div>
</div>
<p class="first first-in-chapter first-full-width">Sign up today to be the first to hear about new releases and exclusive offers, including free and discounted ebooks!</p>
<div class="inline-image inline-image-kind-photograph inline-image-size-small inline-image-flow-center inline-image-flow-within-text inline-image-aspect-wide inline-image-without-caption inline-image-after-section-begin inline-image-before-element-end">
<div class="inline-image-container">
<a class="link-contains-image" href="http://deals.bloodhoundbooks.com/bloodhound-deals" target="_blank">
<img alt="" src="images/sign-up.jpg"/>
</a>
</div>
</div>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width">Why not like us or follow us on social media to stay up to date with the latest news from your favourite authors?</p>
<div class="social-media-profiles as-icons">
<p class="social-profile"><a href="https://www.facebook.com/bloodhoundbooks" target="_blank"><span class="social-profile-image-decorator"><span class="social-profile-image-size-container"><img alt="Facebook icon" class="social-profile-image" src="images/social-facebook-screen.png"/></span></span> <span class="social-profile-text">Facebook</span></a></p>
<p class="social-profile"><a href="https://twitter.com/Bloodhoundbook" target="_blank"><span class="social-profile-image-decorator"><span class="social-profile-image-size-container"><img alt="Twitter icon" class="social-profile-image" src="images/social-twitter-screen.png"/></span></span> <span class="social-profile-text">Twitter</span></a></p>
<p class="social-profile"><a href="https://www.instagram.com/bloodhoundbooks_publishing" target="_blank"><span class="social-profile-image-decorator"><span class="social-profile-image-size-container"><img alt="Instagram icon" class="social-profile-image" src="images/social-instagram-screen.png"/></span></span> <span class="social-profile-text">Instagram</span></a></p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// lovebestsellingfiction.vue?461c26a1